import { useState } from 'react';
import { apiPost, apiPut } from '../../../utils/apiClient';
import './css/changepwmodal.css';

const ChangePwModal = ({ onClose }) => {
  const [step, setStep] = useState(1);
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (!currentPw) {
      setError('현재 비밀번호를 입력해주세요.');
      return;
    }
    if (currentPw.length < 8) {
      setError('비밀번호는 최소 8자 이상이어야 합니다.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await apiPost('/admin/employee/changePw/verify', { currentPw });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.message || '현재 비밀번호가 일치하지 않습니다.');
        return;
      }
      setStep(2);
    } catch (e) {
      setError('현재 비밀번호 확인 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = async () => {
    if (!newPw || !confirmPw) {
      setError('새 비밀번호를 입력해주세요.');
      return;
    }
    if (newPw.length < 8) {
      setError('새 비밀번호는 최소 8자 이상이어야 합니다.');
      return;
    }
    if (newPw !== confirmPw) {
      setError('새 비밀번호와 비밀번호 확인이 일치하지 않습니다.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await apiPut('/admin/employee/changePw', { currentPw, newPw, confirmPw });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.message || '비밀번호 변경에 실패했습니다.');
        return;
      }
      alert('비밀번호가 성공적으로 변경되었습니다.');
      onClose();
    } catch (e) {
      setError('비밀번호 변경 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      step === 1 ? handleVerify() : handleChange();
    }
  };

  return (
    <div className="cpw-overlay">
      <div className="cpw-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cpw-header">
          <h5 className="cpw-title">비밀번호 변경</h5>
          <button className="cpw-close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="cpw-body">
          {step === 1 ? (
            <>
              <p className="cpw-step-desc">현재 비밀번호를 입력해주세요.</p>
              <div className="cpw-field">
                <label className="cpw-label">현재 비밀번호</label>
                <input
                  type="password"
                  className="cpw-input"
                  placeholder="현재 비밀번호"
                  value={currentPw}
                  onChange={(e) => setCurrentPw(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoFocus
                />
              </div>
            </>
          ) : (
            <>
              <p className="cpw-step-desc">새 비밀번호를 입력해주세요.</p>
              <div className="cpw-field">
                <label className="cpw-label">새 비밀번호</label>
                <input
                  type="password"
                  className="cpw-input"
                  placeholder="새 비밀번호(8자리 이상)"
                  value={newPw}
                  onChange={(e) => setNewPw(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoFocus
                />
              </div>
              <div className="cpw-field">
                <label className="cpw-label">새 비밀번호 확인</label>
                <input
                  type="password"
                  className="cpw-input"
                  placeholder="새 비밀번호 확인(8자리 이상)"
                  value={confirmPw}
                  onChange={(e) => setConfirmPw(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>
            </>
          )}

          {error && <p className="cpw-error">{error}</p>}
        </div>

        <div className="cpw-footer">
          {step === 1 ? (
            <button className="cpw-btn-primary" onClick={handleVerify} disabled={loading}>
              {loading ? '확인 중...' : '확인'}
            </button>
          ) : (
            <>
              <button className="cpw-btn-secondary" onClick={() => { setStep(1); setError(''); }}>
                이전
              </button>
              <button className="cpw-btn-primary" onClick={handleChange} disabled={loading}>
                {loading ? '변경 중...' : '변경'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangePwModal;